export default __webpack_public_path__ + "static/media/users.08fff602.svg";